module.exports = __webpack_public_path__ + "static/kentpark-prod-alt-gorsel-a40b52a5ead10828b2a329a9b5f50b8a.webp";